// Types
import type { AxiosInstance } from "axios"
import type { SuccessFetch } from "types"

// Types
interface ReturnBalance {
  totaldeposit: number
  totalpo: number
}

export function fetchCurrentBalance(
  api: AxiosInstance,
  purchase_order_id: string
): Promise<ReturnBalance> {
  return new Promise<ReturnBalance>(async (resolve) => {
    return api.get(
      "/depositvendor/total_approved_deposit_by_po",
      { params: { purchase_order_id } }
    ).then((res: SuccessFetch<{
      payload: {
        totaldeposit: string
        totalpo: string
      }
    }>) => {
      // Vars
      const payload = res.data.payload

      resolve({
        totaldeposit: parseFloat(payload.totaldeposit.toString()),
        totalpo: parseFloat(payload.totalpo.toString())
      })
    }).catch(() => {
      resolve({
        totaldeposit: 0,
        totalpo: 0
      })
    })
  })
}